// extracted by mini-css-extract-plugin
module.exports = {"top":"_3Aq3TKFMnW","form-price":"_2jUOI55UsN","width-160":"VjYwvlus96","content":"_1x5AA_17n_","sort":"_3lTpW6xh-T","list-img":"eJDW7TzW3c"};